import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import injectCss from 'react-jss';
import R from 'ramda';
import {
  FlatButton,
  FontIcon,
  Paper,
  TextField,
  RaisedButton,
} from 'material-ui';

import {
  goBack as goBackAction,
} from 'react-router-redux';
import {
  createTemplate as createTemplateAction,
  typeName as typeNameAction,
} from './__storeFiles__/actions';


class CreateSecondaryTemplateRouter extends Component {

  render() {
    const {
      classes,
      goBack,
      templateName,
      createTemplate,
      typeName,
      creating,
    } = this.props;
    return (
      <div className="l-app-content">
        <Paper className={classes.paperContainer}>
          <div className={classes.headerContainer}>
            <h4 className={classes.title}>Create Corporate Policies & Notes Template</h4>
            <FlatButton
              icon={<FontIcon className="tc-icon-arrow_back" color="white" />}
              label="back"
              style={{ color: 'white' }}
              onTouchTap={goBack}
            />
          </div>
          <div className={classes.body}>
            <p style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
              Corporate Policies & Notes allow you to create master policies that can be shared across multiple templates. If you ever need to update these policies or notes, all you’ll need to do is update the master, and we’ll update the associated templates.
            </p>
            <TextField
              value={templateName}
              floatingLabelText="Template Name"
              underlineStyle={{ borderColor: '#00bcd4' }}
              onChange={typeName}
            />
            <br/>
            <br/>
            <RaisedButton
              label={creating ? 'Creating' : 'Create'}
              disabled={creating}
              secondary
              onTouchTap={createTemplate}
            />
          </div>
        </Paper>
      </div>
    );
  }
}

CreateSecondaryTemplateRouter.propTypes = {
  goBack: PropTypes.func,
  replace: PropTypes.func,
  classes: PropTypes.object,
  createTemplate: PropTypes.func,
  templateName: PropTypes.string,
  typeName: PropTypes.func,
  creating: PropTypes.bool,
};

const mapStateToProps = ({
   contracting: {
     masterTemplate: {
       createNew,
     },
   },
 }) => createNew;

export default connect(
  mapStateToProps,
  {
    goBack: goBackAction,
    createTemplate: createTemplateAction,
    typeName: typeNameAction,
  },
)(injectCss({
  paperContainer: {
    width: '700px',
    margin: 'auto',
  },
  headerContainer: {
    backgroundColor: '#00bcd4',
    color: '#fff',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    width: '70%',
    color: '#FFFFFF',
    fontWeight: '500',
    paddingRight: '32px',
    textAlign: 'right',
  },
  body: {
    padding: '24px',
    paddingBottom: '32px',
  },
})(CreateSecondaryTemplateRouter));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template-list/create-master-template.jsx